export default __webpack_public_path__ + "static/tea4-fab980c7badada8e16d2ef0c2e86f9b7.png";